import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
	interviewQuestionsGet,
	interviewQuestionGetById,
	interviewQuestionCreate,
	interviewQuestionUpdate,
	interviewQuestionDelete,
	interviewQuestionPromote
} from "api/menu/hr/interview-questions/requests";

export const FETCH_INTERVIEW_QUESTIONS_SUCCESS = "FETCH_INTERVIEW_QUESTIONS_SUCCESS";
export const FETCH_INTERVIEW_QUESTION_BY_ID_SUCCESS = "FETCH_INTERVIEW_QUESTION_BY_ID_SUCCESS";
export const INTERVIEW_QUESTIONS_REQUEST_LOADING = "INTERVIEW_QUESTIONS_REQUEST_LOADING";
export const INTERVIEW_QUESTIONS_REQUEST_ERRORS = "INTERVIEW_QUESTIONS_REQUEST_ERRORS";

export const setLoading = () => ({ type: INTERVIEW_QUESTIONS_REQUEST_LOADING });

export const fetchInterviewQuestions = (categoryId = null, includeInactive = false) => dispatch => {
	dispatch(setLoading());
	interviewQuestionsGet(categoryId, includeInactive)
		.then(response => {
			dispatch({ type: FETCH_INTERVIEW_QUESTIONS_SUCCESS, payload: response.data });
		})
		.catch(error => {
			dispatch(defaultErrorHandler(error, INTERVIEW_QUESTIONS_REQUEST_ERRORS));
		});
};

export const fetchInterviewQuestionById = (id) => dispatch => {
	interviewQuestionGetById(id)
		.then(response => {
			dispatch({ type: FETCH_INTERVIEW_QUESTION_BY_ID_SUCCESS, payload: response.data });
		})
		.catch(error => {
			dispatch(defaultErrorHandler(error, INTERVIEW_QUESTIONS_REQUEST_ERRORS));
		});
};

export const createInterviewQuestion = (data, callback = false) => dispatch => {
	dispatch(formErrorLoading());
	interviewQuestionCreate(data)
		.then(response => {
			dispatch(formErrorLoading(false));
			toast("Interview question created", { type: toast.TYPE.SUCCESS });
			if (callback) callback(response.data);
		})
		.catch(error => {
			dispatch(formErrorsHandler(error));
		});
};

export const updateInterviewQuestion = (id, data, callback = false) => dispatch => {
	dispatch(formErrorLoading());
	interviewQuestionUpdate(id, data)
		.then(() => {
			dispatch(formErrorLoading(false));
			toast("Interview question updated", { type: toast.TYPE.SUCCESS });
			if (callback) callback(true);
		})
		.catch(error => {
			dispatch(formErrorsHandler(error));
		});
};

export const deleteInterviewQuestion = (id, callback = false) => dispatch => {
	dispatch(setLoading());
	interviewQuestionDelete(id)
		.then(() => {
			toast("Interview question deleted", { type: toast.TYPE.SUCCESS });
			if (callback) callback();
		})
		.catch(error => {
			dispatch(defaultErrorHandler(error, INTERVIEW_QUESTIONS_REQUEST_ERRORS));
		});
};

export const promoteInterviewQuestion = (data, callback = false) => dispatch => {
	dispatch(formErrorLoading());
	interviewQuestionPromote(data)
		.then(response => {
			dispatch(formErrorLoading(false));
			if (response.data && response.data.wasDuplicate) {
				toast("Question already exists in the bank", { type: toast.TYPE.WARNING });
			} else {
				toast("Question promoted to bank", { type: toast.TYPE.SUCCESS });
			}
			if (callback) callback(response.data);
		})
		.catch(error => {
			dispatch(formErrorsHandler(error));
		});
};

export const clearInterviewQuestions = () => dispatch => {
	dispatch({ type: FETCH_INTERVIEW_QUESTIONS_SUCCESS, payload: [] });
};

export const clearSingleInterviewQuestion = () => dispatch => {
	dispatch({ type: FETCH_INTERVIEW_QUESTION_BY_ID_SUCCESS, payload: {} });
};
